import { Component, OnInit } from '@angular/core';
import { hazardMaster } from '../../../Models/HazardMasterModel';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CheckAuth } from '../../../Services/UtilityService';
import { inductryMaster } from '../../../Models/InductryMasterModel';
import { AdminHazardMasterServices } from '../../../Services/Admin/HazardServices';
import { SelectedListModel } from '../../../Models/SelectedList';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-manage-hazards',
  templateUrl: './manage-hazards.component.html',
  styleUrls: ['./manage-hazards.component.css']
})

export class ManageHazardsComponent implements OnInit {
  tokenKey: string = '';
  hazardMaster = new hazardMaster();
  statusCode: number = 0;
  insertedHazardMasterId: number = 0;
  buttonText: string = '';
  updateDeleteID: string = '';
  hazardMasterID: string;

  inductryMaster: inductryMaster[] = [];
  selectedInductryMaster: inductryMaster[] = [];

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};


  arrayString: string = '';
  saprator: string = '';

  hazardForm = new FormGroup({
    hazardMasterId: new FormControl(''),
    hazardName: new FormControl('', Validators.required),
    industryId: new FormControl(''),
    isActive: new FormControl('true', Validators.required),
    isSelected: new FormControl(''),
    displayOrder: new FormControl(''),
    totalRecords: new FormControl(''),
    selectedItems1: new FormControl('')
  });

  constructor(private toastr: ToastrService, private checkAuth: CheckAuth, private router: Router, private activedRoute: ActivatedRoute, private hazardServices: AdminHazardMasterServices) {
    this.hazardMaster.isActive = "true"
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    //this.hazardMasterID = 10;
    this.buttonText = 'Save';

    this.activedRoute.params.subscribe((params: Params) => {
      this.hazardMasterID = params['id'];
      if (this.hazardMasterID != null) {
        this.buttonText = "Update";
      }
    });

    //this.setMultiSelectProperty();
    this.GetIndustryMaster();
  }

  GetIndustryMaster() {
    this.hazardServices.GetHazardMasterFindByMultipleInductry(this.tokenKey, this.hazardMasterID)
      .subscribe(
        data => {
          debugger;
          this.inductryMaster = data["inductryMaster"];          
          this.setMultiSelectProperty();
        }, error => this.statusCode = error);
  }

  // Multi Select DropDown Property
  setMultiSelectProperty() {
    if (Array.isArray(this.inductryMaster)) {
      // Set All Item
      for (let iCounter = 0; iCounter < this.inductryMaster.length; iCounter++) {
        this.dropdownList.push(
          { "id": this.inductryMaster[iCounter].inductryId, "itemName": this.inductryMaster[iCounter].inductryName }
        );
      }

      // Set Multi Selected Item
      this.selectedInductryMaster = this.inductryMaster.filter(m => +m.hazardMasterId != 0);
      for (let iCounter = 0; iCounter < this.selectedInductryMaster.length; iCounter++) {
        debugger;
        this.hazardMaster.hazardMasterId = this.selectedInductryMaster[iCounter].hazardMasterId;
        this.hazardMaster.hazardName = this.selectedInductryMaster[iCounter].hazardName;
        this.hazardMaster.hazardMasterId = this.selectedInductryMaster[iCounter].hazardMasterId;
        this.hazardMaster.isActive = this.selectedInductryMaster[iCounter].isActive;
        this.selectedItems.push(
          { "id": this.selectedInductryMaster[iCounter].inductryId, "itemName": this.selectedInductryMaster[iCounter].inductryName }
        );
      }
    }

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select Inductry",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: "myclass custom-class"
    };
  }

  onItemSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  onSelectAll(items: any) {
    console.log(items);
  }
  onDeSelectAll(items: any) {
    console.log(items);
  }

  returnToHazardList() {
    this.router.navigate(['/admin/hazards']);
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  saveHazard(hazardForm: NgForm) {
    this.hazardMaster = hazardForm.value;
    debugger;

    let obj = hazardForm.value["selectedItems1"]

    if(this.hazardMaster.hazardName == "" || this.hazardMaster.hazardName == undefined)
    {
      this.showMessage('Please enter Hazard Name', 'Error', 'error');
      return;
    }
    else if (obj == null || obj == undefined || obj == "") {
      this.showMessage('Please select at list one industry', 'Error', 'error');
      return;
    }
    

    if (obj != null) {
      this.arrayString += '[';
      for (let iCounter = 0; iCounter < obj.length; iCounter++) {
        this.arrayString += this.saprator + "{ 'itemId': " + obj[iCounter].id + ", 'itemName': '" + obj[iCounter].itemName + "' }";
        this.saprator = ',';
      }
      this.arrayString += ']';
    }

    if (this.hazardMaster != null) {
      if (parseInt(this.hazardMaster.hazardMasterId) > 0) {
        this.hazardServices.AddUpdateHazardMaster(this.tokenKey, this.arrayString, this.hazardMaster.hazardName, this.hazardMaster.isActive, '0', this.hazardMasterID.toString())
          .subscribe(industryId => {
            debugger;
            this.setOprationSession('Edited');
            this.router.navigate(['/admin/hazards']);
          },
            error => this.statusCode = error);
      }
      else {
        this.hazardServices.AddUpdateHazardMaster(this.tokenKey, this.arrayString, this.hazardMaster.hazardName, this.hazardMaster.isActive, '0', 'null')
          .subscribe(industryId => {
            debugger;
            this.setOprationSession('Added');
            this.router.navigate(['/admin/hazards']);
          },
            error => this.statusCode = error);
      }
    }
  }

  setOprationSession(AddEdit: string) {
    sessionStorage.setItem('HazardCRUDStatus', AddEdit);
  }

}
